<ng-container *ngIf="isReadOnly; else showInputDatePicker">
  <div class="p-text-bold-500">
    {{ getFormattedDataRangeStr() | replaceNullWith : '-' }}
  </div>
</ng-container>
<ng-template #showInputDatePicker>
  <sigv-date-range-picker
    (ngModelChange)="ngModelChangeEvent()"
    [(ngModel)]="model"
    [fieldName]="fieldName"
    [readonlyInput]="readonlyInput"
    [appendTo]="appendTo"
    [dateFormat]="dateFormat"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [yearRange]="yearRange"
    [showTime]="showTime"
    [stepMinute]="stepMinute"
    [readonly]="readonly"
    [rangeSetting]="rangeSetting"
    [greaterThenSysDateCheck]="greaterThenSysDateCheck"
    [lessThenSysDateCheck]="lessThenSysDateCheck"
    (getControl)="util.rangeControl = $event"
    (backspacePressed)="handleBackspacePress()"
    (dateClear)="onDateClear($event)"
    [submitTouched]="submitTouched"
    [forceUpdateValueAndValidity]="forceUpdateValueAndValidity"
    [isDateRangeRequired]="this.isDateRangeRequired"
  >
  </sigv-date-range-picker>
</ng-template>
